// @ts-ignore
import HTML from 'html-parse-stringify';
import { createElement, Fragment } from 'react';
import { useT } from './useT';
const toArray = (v) => (Array.isArray(v) ? v : [v]);
const DEFAULT_OPTIONS = {
    transEmptyNodeValue: '',
    transKeepBasicHtmlNodesFor: ['br', 'i', 'p', 'strong'],
    transSupportBasicHtmlNodes: true,
};
const renderNodes = (tString, reactOpts, Text) => {
    if (tString === '')
        return [];
    // NOTE: We wrap in a dummy tag, otherwise, any starting text nodes will be
    //  ignored. This is also what react-i18next does.
    const [ast] = HTML.parse(`<0>${tString}</0>`);
    const keepArray = new Set(reactOpts.transKeepBasicHtmlNodesFor);
    const mapAST = (ast) => {
        const astNodes = toArray(ast);
        return astNodes.reduce((nodes, node, i) => {
            if (node.type === 'tag') {
                const tagName = node.name;
                // If node is a tag, we recurse the children
                const children = mapAST(node.children);
                // Only render explicitly allowed tags
                if (keepArray.has(tagName)) {
                    const el = Text || tagName;
                    const key = `${tagName}-${i}`;
                    let props;
                    // If `Text` component was specified, we call it with attrs as props
                    if (Text) {
                        const { attrs } = node;
                        props = { key, type: tagName };
                        // Copy in node attrs, and normalize boolean attributes
                        for (const k in attrs) {
                            const v = attrs[k];
                            props[k] = v === '' || v;
                        }
                    }
                    else {
                        // "Basic" node is just called with key
                        props = { key };
                    }
                    nodes.push(createElement(el, props, children));
                }
                else {
                    // All environments we use have a console global, but there's no
                    // reason to specifically add types for Node, React Native, or DOM.
                    // @ts-ignore
                    console.warn(`Did not recognize node ${tagName}. Only rendering children...`);
                    nodes.push(children);
                }
            }
            else if (node.type === 'text') {
                const { content } = node;
                if (Text) {
                    nodes.push(createElement(Text, { key: `text-${i}` }, content));
                }
                else {
                    nodes.push(content);
                }
            }
            // NOTE: We ignore `ComponentNode`, like the original `Trans`
            return nodes;
        }, []);
    };
    return mapAST(ast.children);
};
/**
 * This is an abbreviated version of react-i18next Trans component, which has
 * been modified to support a custom Text component, and stripped of unused
 * features. If a Text component is passed to the provider, we will use that
 * to translate tags, otherwise, we'll use the default behavior.
 *
 * NOTE: This implementation is missing several things and doesn't behave the
 *  same as the original.
 *  - First, it does not support `children` and therefore does not do any of
 *  the translation assistance stuff.
 *  - Second, it's missing some options like `shouldUnescape`, `ns`,
 *  `defaults`, `parent`, etc.
 *  - Third, it does not run `interpolate` on the individual string nodes, so
 *  it doesn't support embedded translations (e.g. `$t(someKey)`). Most if not
 *  all of these omissions could be added if we need the functionality.
 *
 * Go here for an up-to-date look at the `Trans` component in case this becomes
 * out of date and needs to be modified.
 * @see https://react.i18next.com/latest/trans-component
 */
export const Trans = ({ context, count, i18nKey, t: tFromProps, tOptions = {}, values, }) => {
    const [tFromContext, i18n, Text] = useT();
    const t = (tFromProps || tFromContext);
    const ns = t.ns || i18n.options.defaultNS || '';
    const reactOpts = { ...DEFAULT_OPTIONS, ...i18n.options.react };
    const combinedTOptions = {
        ...tOptions,
        context,
        count,
        ns,
        ...values,
    };
    return createElement(Text || Fragment, {}, renderNodes(t(i18nKey, combinedTOptions), reactOpts, Text));
};
//# sourceMappingURL=Trans.js.map